/**
 * Featured Product (Desktop): Thumbnail-Leiste per Maus/Touch ziehen.
 * Klicks auf Thumbnails bleiben für media-gallery.js erhalten.
 */
(function () {
  const ROOT = '.rf-featured-product--thumbnails';
  const LIST = '.thumbnail-slider .thumbnail-list.slider';
  const DRAGGING_CLASS = 'rf-thumbnail-list--dragging';
  const DRAG_THRESHOLD_PX = 6;

  const desktopMql = window.matchMedia('(min-width: 750px)');

  function bindDragScroll(list) {
    if (!list || list.dataset.rfThumbnailDragBound === 'true') return;
    list.dataset.rfThumbnailDragBound = 'true';

    let active = false;
    let didDrag = false;
    let suppressClick = false;
    let startX = 0;
    let startScroll = 0;

    const endDrag = () => {
      if (!active) return;
      active = false;
      list.classList.remove(DRAGGING_CLASS);
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
      document.removeEventListener('pointercancel', onPointerUp);
      if (didDrag) {
        window.setTimeout(() => {
          suppressClick = false;
        }, 250);
      }
    };

    const onPointerMove = (event) => {
      if (!active) return;

      const dx = event.clientX - startX;
      if (Math.abs(dx) <= DRAG_THRESHOLD_PX) return;

      didDrag = true;
      suppressClick = true;
      list.classList.add(DRAGGING_CLASS);
      event.preventDefault();
      list.scrollLeft = startScroll - dx;
    };

    const onPointerUp = () => {
      endDrag();
    };

    list.addEventListener('pointerdown', (event) => {
      if (!desktopMql.matches) return;
      if (event.button !== 0) return;

      active = true;
      didDrag = false;
      suppressClick = false;
      startX = event.clientX;
      startScroll = list.scrollLeft;

      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
      document.addEventListener('pointercancel', onPointerUp);
    });

    list.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  function init(scope) {
    if (!desktopMql.matches) return;

    const container =
      scope && typeof scope.matches === 'function' && scope.matches(ROOT)
        ? scope
        : scope?.querySelector?.(ROOT) || document.querySelector(ROOT);

    if (!container) return;

    container.querySelectorAll(LIST).forEach(bindDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
